const VjsTable = (() => {
    const bootstrapTableDefaultOptions = {
        onPreBody() {
            if (typeof this.default_sortName === 'undefined') {
                this.default_sortName = this.sortName;
            }
            if (typeof this.default_sortOrder === 'undefined') {
                this.default_sortOrder = this.sortOrder;
            }

            if ($.urlParam('order_by') !== null) {
                this.sortName = $.urlParam('order_by');
            }
            if ($.urlParam('sort_order') !== null) {
                this.sortOrder = $.urlParam('sort_order');
            }

            this.searchText = $.urlParam('search_term') !== null ? decodeURIComponent($.urlParam('search_term')) : null;

            $(document).off('keyup', '.fixed-table-toolbar .search .form-control');
            const thisTable = this;
            $(document).on('keyup', '.fixed-table-toolbar .search .form-control', () => {
                thisTable.searchText = $(this).val();
                thisTable.updateUrl();
            });
        },
        onPostHeader() {
            // this code here will update the colspan on the date_range cell if there is one...
            let rowspans = 0;
            let colspans = 0;
            let dateRangeCell = null;
            if (typeof this.table !== 'undefined') {
                $(`${this.table} thead th`).each(() => {
                    if (
                        (typeof $(this).attr('rowspan') === 'undefined' || +$(this).attr('rowspan') === 1)
                        && typeof $(this).attr('colspan') === 'undefined'
                    ) {
                        rowspans++;
                    }
                    if (typeof $(this).attr('colspan') !== 'undefined') {
                        colspans++;
                        dateRangeCell = this;
                    }
                });
                if (colspans === 1) {
                    $(dateRangeCell).attr('colspan', rowspans);
                }
            }
        },
        onLoadError(status) {
            if (+status === 401) {
                // location.reload();
            } else if (+status === 0) {
                // ajax cancelled
                if (typeof this.table !== 'undefined') {
                    $(this.table).addClass('loading');
                    $(this.table).bootstrapTable('showLoading');
                }
            } else if (+status === 500 || +status === 404) {
                // eslint-disable-next-line no-new, new-cap
                new PNotify.error({
                    title: 'Load Error',
                    text: 'Service cannot be reached!',
                    icon: 'fa fa-exclamation-triangle',
                    type: 'error',
                });
            }
        },
        formatLoadingMessage() {
            return '<i class="fa fa-refresh fa-spin fa-fw" style="margin-top: 10px;"></i>';
        },
        formatNoMatches() {
            return 'No records found!';
        },
        onLoadSuccess() {
            $('time.timeago').timeago();
            $('.fixed-table-toolbar .search > input').val(this.searchText);
            if (typeof this.table !== 'undefined') {
                $(this.table).removeClass('loading');
                $(this.table).bootstrapTable('hideLoading');
            }
            $('.bootstrap-table').removeClass('sel-bootstrap-table-loading').addClass('sel-bootstrap-table-loaded');
        },
        onSearch() {
            if (typeof this.table !== 'undefined') {
                $(this.table).addClass('loading');
                $(this.table).bootstrapTable('showLoading');
            }
            this.updateUrl();
        },
        onRefresh() {
            if (typeof this.table !== 'undefined') {
                $(this.table).addClass('loading');
                $(this.table).bootstrapTable('showLoading');
            }
        },
        onSort() {
            if (typeof this.table !== 'undefined') {
                $(this.table).addClass('loading');
                $(this.table).bootstrapTable('showLoading');
            }
            this.updateUrl();
        },
        updateUrl(queryParams = {}) {
            if (this.sortName !== this.default_sortName) {
                queryParams.order_by = this.sortName;
            }
            if (this.sortOrder !== this.default_sortOrder) {
                queryParams.sort_order = this.sortOrder;
            }
            if (this.searchText != null && this.searchText !== '') {
                queryParams.search_term = this.searchText;
            }

            const queryString = $.param(queryParams);
            let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

            if (queryString !== '') {
                newurl += `?${queryString}`;
            }

            window.history.pushState({ path: newurl }, '', newurl);
        },
        method: 'post',
        contentType: 'application/x-www-form-urlencoded',
        classes: 'table table-hover table-condensed',
        striped: true,
        showRefresh: true,
        showToggle: false,
        showColumns: false,
        showPaginationSwitch: false,
        // searchOnEnterKey: true,
        searchTimeOut: 1000,
        minimumCountColumns: '2',
        pagination: true,
        search: true,
        searchAlign: 'left',
        toolbar: '#report-toolbar',
        toolbarAlign: 'left',
        sortOrder: 'desc',
        clickToSelect: false,
        maintainSelected: false,
        sidePagination: 'server',
        paginationVAlign: 'both',
        pageSize: 25,
        queryParamsType: 'other',
        async: true,
        icons: {
            refresh: 'fa-sync fa-refresh',
        },
        queryParams(params) {
            $('.bootstrap-table').removeClass('sel-bootstrap-table-loaded').addClass('sel-bootstrap-table-loading');
            const myParams = {};
            if (typeof params !== 'undefined') {
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;
                myParams.active = params.active;
                myParams.role = params.role;
            } else {
                myParams.search_term = this.searchText;
                myParams.page = this.pageNumber;
                myParams.page_size = this.pageSize;
                myParams.order_by = this.sortName;
                myParams.sort_order = this.sortOrder;
            }
            return myParams;
        },
        responseHandler(res) {
            const formattedResult = {};
            formattedResult.total = res.meta.total;
            formattedResult.rows = res.data;

            $(formattedResult.rows).each((i, result) => {
                // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                VjsAdmin.convertDateRow(result, 'MM/DD/YYYY');
            });
            return formattedResult;
        },
        rowStyle(row) {
            const classes = +row.is_active === 0 ? 'danger' : '';

            return { classes };
        },
    };

    // simple table defaults
    const simpleTableDefaultOptions = {
        ...bootstrapTableDefaultOptions,
        onPreBody() {},
        updateUrl() {},
        onSearch() {},
        onRefresh() {},
        onSort() {},
        icons: {
            refresh: 'fa-refresh fa-sync',
        },

        searchTimeOut: 500,
    };

    const tableDefaults = () => bootstrapTableDefaultOptions;

    const simpleTableDefaults = () => simpleTableDefaultOptions;

    return {
        tableDefaults,
        simpleTableDefaults,
    };
})();
